var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportCartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66829 29.6667H39.3183C41.6816 29.6667 42.8632 29.6667 43.8039 29.2261C44.6325 28.838 45.3288 28.2148 45.8061 27.4341C46.3478 26.5478 46.4783 25.3734 46.7393 23.0246L48.1043 10.7396C48.184 10.0221 48.2239 9.66343 48.1085 9.38579C48.0072 9.14194 47.8262 8.93968 47.595 8.81206C47.3318 8.66675 46.9709 8.66675 46.2491 8.66675H7.50163M1.66797 1.66675H4.58099C5.19845 1.66675 5.50717 1.66675 5.74871 1.78417C5.96134 1.88755 6.13755 2.05309 6.25399 2.25886C6.38625 2.4926 6.40551 2.80073 6.44402 3.41698L8.55858 37.2499C8.5971 37.8661 8.61635 38.1742 8.74861 38.408C8.86505 38.6137 9.04126 38.7793 9.2539 38.8827C9.49543 39.0001 9.80416 39.0001 10.4216 39.0001H41.3346M14.5013 47.1667H14.5246M35.5013 47.1667H35.5246M15.668 47.1667C15.668 47.8111 15.1456 48.3334 14.5013 48.3334C13.857 48.3334 13.3346 47.8111 13.3346 47.1667C13.3346 46.5224 13.857 46.0001 14.5013 46.0001C15.1456 46.0001 15.668 46.5224 15.668 47.1667ZM36.668 47.1667C36.668 47.8111 36.1456 48.3334 35.5013 48.3334C34.857 48.3334 34.3346 47.8111 34.3346 47.1667C34.3346 46.5224 34.857 46.0001 35.5013 46.0001C36.1456 46.0001 36.668 46.5224 36.668 47.1667Z",
    stroke: "#27AE60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportCartIcon);
export default __webpack_public_path__ + "static/media/support-cart-icon.bebfdc2d5e3c2c1fe7c3568a9e8859aa.svg";
export { ForwardRef as ReactComponent };